'use strict';

angular.module('amexReconciliationApp')
  .component('adminToolbar', {
    templateUrl: 'scripts/views/directives/admin-toolbar.html',
    controller: function (UserModel, 
                          UserRepository, 
                          CompanyRepository, 
                          TransactionsModel, 
                          BillingCycleModel,
                          NotificationsRepository,
                          $http,
                          $state) {
      var self = this;

      self.$onInit = function () {
        self.companies = [];
        self.currentCompany = undefined;
        self.emulatedUser = undefined;
        self.loggedInUser = undefined;
        self.isBCAManagerViewSelected = UserModel.isBCAManagerViewSelected ;
        CompanyRepository.findAllCompanies()
          .then(function (companies) {
            self.companies = companies; })
          .then(updatePreviousUser)
          .then(reloadEmulatedUser);
      };

    self.handleCompanySelect = function ($item) {
        if (self.isBCAManagerViewSelected) {
          self.handleUserSelect(self.loggedInUser);
        } else {
            return CompanyRepository.getUsersForCompany($item.companyId)
                .then(function (users) {
                    $item.users = _.map(users, function (user) {
                        user.displayName = formatUser(user);
                        return user;
                    });
                });
        }
    };
      self.shouldDisableUserField = function () {
        if (self.currentCompany && self.currentCompany.users) {
          return false;
        }

        self.emulatedUser = undefined;
        return true;
      };

    self.onSelectBCAManagerView = function () {

        if (self.isBCAManagerViewSelected) {
            var user = UserModel.currentUser();
            var previousUser = UserModel.previousUser;
            self.loggedInUser.userId = self.loggedInUser.username;
            UserModel.isBCAManagerViewSelected = true;
            self.handleUserSelect(self.loggedInUser);
        } else {
            UserModel.isBCAManagerViewSelected = false;
            self.handleCompanySelect(self.currentCompany);
        }
    };

      self.handleUserSelect = function ($item) {
        TransactionsModel.transactions([]);
        BillingCycleModel.billingCycles([]);

        var switchUser = function () {
            var switchUserURL = '/switch_user?username=' + $item.userId;
            if (self.isBCAManagerViewSelected) {
                switchUserURL = switchUserURL+ '&companyid=' + self.currentCompany.companyId;
            }else {
                NotificationsRepository.notificationsShown = false;
            }
          $http.post(switchUserURL)
            .then(function () {
              updateCurrentUser()
                .then(function() {
                  updatePreviousUser()
                    .then(function() {
                      $state.go('home');
                    });
                })
                .catch(function() {
                  UserModel.setCurrentUser({});
                });
            })
            .catch(function() {
              UserModel.setCurrentUser({});
            });
        };

        if (UserModel.previousUser && UserModel.previousUser.username) {
          $http.post('/switch_user_exit').then(switchUser, switchUser);
        } else {
          switchUser();
        }
      };

      self.adminFullName = function () {
        var user = UserModel.currentUser();
        if (UserModel.previousUser && UserModel.previousUser.username) {
          user = UserModel.previousUser;
        }

        self.loggedInUser = user;
        return user.firstName + ' ' + user.lastName;
      };

      function formatUser(user) {
        if (user) {
          return user.firstName + ' ' + user.lastName + ' (' + user.userId + ')';
        }

        return '';
      }

      function updateCurrentUser() {
        return UserRepository.getAuthenticatedUser()
          .then(UserModel.fetchPreferences)
          .then(UserModel.setCurrentUser);
      }

      function updatePreviousUser() {
        return UserRepository.getPreviousUser().then(function (user) {
          UserModel.previousUser = user;
        });
      }

      function reloadEmulatedUser() {
        var previousUser = UserModel.previousUser;

        if (previousUser) {
          var currentUser = UserModel.currentUser();
          self.currentCompany = _.find(self.companies, ['companyId', currentUser.companyId]);
          if (self.isBCAManagerViewSelected) {
              self.emulatedUser = self.loggedInUser;
          } else {
              self.handleCompanySelect(self.currentCompany).then(function () {
                  self.emulatedUser = _.find(self.currentCompany.users, ['userId', currentUser.username]);
              });
          }
        }
      }
    }
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/directives/adminToolbar.js
// module id = 511
// module chunks = 0